export { default as CTAModule } from './CTAModule';
